import { RequestMethodTypes } from "../helpers/constants";
import { fetchWrapper } from "../helpers";

/**
 * POST /v1/candidate/{oktaSubId}/upload:
 * @param {string} oktaSubId oktaSubId
 * @param {FormData} formData FormData with files and types
 * @returns {Promise<Object>} 
 *  {
 *    "success": true,
      "uploaded": []
    }
 */
export const uploadFiles = async ({ oktaSubId, formData }) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.POST,
    url: `${oktaSubId}/upload`,
    data: formData, // Send FormData directly
  });

  return response?.data;
};

/**
 * GET /v1/candidate/{oktaSubId}/download?fileId=xxx:
 * @param {string} oktaSubId oktaSubId
 * @param {string} fileId file identifier
 * @returns {Promise<Blob>} File blob
 */
export const downloadFile = async ({ oktaSubId, fileId }) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url: `${oktaSubId}/download?fileId=${encodeURIComponent(fileId)}`,
    responseType: "blob",
  });

  if (!response || response.status !== 200) {
    throw new Error(
      `Download failed: ${response?.status} ${response?.statusText}`
    );
  }

  return response?.data;
};
